const reviews = [
  {
    name: 'Наталья К.',
    role: 'Невролог, Москва',
    text: 'Впервые на конференции, где не хотелось уходить на обед. Стендап между секциями — это гениально. Смеялись всем залом, а потом снова слушали доклады с новыми силами.',
    stars: 5,
  },
  {
    name: 'Андрей В.',
    role: 'Кардиолог, Санкт-Петербург',
    text: 'Формат диалога, а не монолога — это то, чего не хватает большинству конференций. Здесь можно задать вопрос и получить честный ответ, а не заготовленную речь.',
    stars: 5,
  },
  {
    name: 'Елена М.',
    role: 'Педиатр, Пермь',
    text: 'Приехала с коллегой, остались на оба дня. Прогулка по Лавре после второго дня — отдельное удовольствие. Уехала с новыми знаниями и новыми друзьями.',
    stars: 5,
  },
  {
    name: 'Дмитрий Р.',
    role: 'Ординатор, Санкт-Петербург',
    text: 'Как ординатор, боялся, что буду чувствовать себя лишним. Но атмосфера такая, что сразу включаешься. AI-болит во время обеда — отдельный восторг.',
    stars: 5,
  },
];

export default function ReviewsSection() {
  return (
    <section className="py-20 md:py-28 bg-[#f5f2ed]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0f3d32] mb-4">
            Что говорят участники
          </h2>
          <p className="text-gray-500 text-lg">Отзывы с прошлых конференций</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r) => (
            <div key={r.name} className="bg-white rounded-2xl p-6 flex flex-col gap-4">
              <div className="flex gap-1">
                {Array.from({ length: r.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c8963e] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed flex-1">&ldquo;{r.text}&rdquo;</p>
              <div>
                <div className="font-bold text-[#0f3d32] text-sm">{r.name}</div>
                <div className="text-gray-400 text-xs mt-0.5">{r.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
